import { PRO_GIG_PAGE_UPDATE } from '../experimentsEnum';
import { inAbTest } from '..';

export default (abTests) => inAbTest(abTests, PRO_GIG_PAGE_UPDATE);
